<template>
  <div>
    <HeaderTop></HeaderTop>
    <div class="paperPage">
      <div class="mid">
        <div class="mianbao mt2">
          <span class="dq">当前位置：</span>
          <span @click="toRouter('/main/home')" class="mba  click">个人中心</span>
          &gt;
          <span @click="toRouter('/main/evaluation')" class="mba  click">知识点测验</span>
          &gt;
          <span class="site ">详情</span>
        </div>
        <div class="content">
          <div class="paperBox">
            <div class="treeBox">
              <el-tree ref="treeBox" node-key="id" :data="treeData" :props="defaultProps" highlight-current>
                <span slot-scope="{ node, data }" class="tree-node-label" :class="{ 'is-disabled': data.disabled }"
                  @click.stop="handleTreeNodeSelect(data)">
                  {{ node.label }}
                </span>
              </el-tree>
            </div>
            <div class="list">
              <div class="li" v-for="(item, index) in sections" :key="index">
                <div class="titleBox" v-if="item.questions">
                  <p>{{ index + 1 }}、{{ item.name || item.questionType }}</p>
                </div>
                <div class="liBox" v-for="(question, indexQ) in item.questions" :key="'q' + indexQ"
                  :id="'Q-' + question.id">

                  <!-- 套题 -->
                  <template v-if="question.type == 'TT'">
                    <div class="title fontSize32">
                      ({{ Number(indexQ) + 1 }})、<span v-html="reformHtml(question.content)"></span>
                    </div>
                    <div class="boxView" v-for="(q, qi) in question.children" :key="'q_' + qi">

                      <template v-if="q.type == 'SINGLECHOICE' || q.type == 'MULTIPLECHOICE' || q.type == 'JUDGMENT'">
                        <choice :info="q" :no="qi" @choose="change" :readOnly="readOnly" :showAnswer="true" :answerExpose="true"></choice>
                      </template>
                      <template v-else-if="q.type == 'BLANKFILL'">
                        <blank :info="q" :no="qi" :readOnly="readOnly" :showAnswer="true" :answerExpose="true" @change="change"></blank>
                      </template>
                      <template v-else>
                        <essay :info="q" :no="qi" :readOnly="readOnly" :showAnswer="true" :answerExpose="true" @change="change"></essay>
                      </template>
                    </div>
                  </template>
                  <!-- 非套题 -->
                  <template v-else>
                    <template v-if="
                      question.type == 'SINGLECHOICE' ||
                      question.type == 'MULTIPLECHOICE' ||
                      question.type == 'JUDGMENT'
                    ">
                      <choice :info="question" :no="indexQ" @choose="change" :readOnly="readOnly" :showAnswer="true" :answerExpose="true"></choice>
                    </template>
                    <template v-else-if="question.type == 'BLANKFILL'">
                      <blank :info="question" :no="indexQ" :readOnly="readOnly" :showAnswer="true" :answerExpose="true" @change="change"></blank>
                    </template>
                    <template v-else>
                      <essay :info="question" :no="indexQ" :readOnly="readOnly" :showAnswer="true" :answerExpose="true" @change="change"></essay>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 答题卡 -->
        <div class="answerBox">
          <cardList :list="sections" @position="position" :readOnly="readOnly" :redo="activeData.recordId"
            @redo="redoFn" :check="check">
          </cardList>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";
import choice from "@/components/question/choice.vue";
import blank from "@/components/question/blank.vue";
import essay from "@/components/question/essay.vue";
import cardList from "@/components/question/evaluationCardList.vue";
export default {
  components: {
    HeaderTop,
    Footer,
    choice,
    blank,
    essay,
    cardList,
  },
  data () {
    return {
      paperId: "",
      configId: "",
      recordId: "",
      treeData: [],
      activeData: {},
      check: [],
      defaultProps: {
        children: 'lessons',
        label: 'name',
        disabled: 'disabled'
      },
      t: "", //答题保存
      redo: true,
      readOnly: true,
      sections: [],
    };
  },
  created () {
    this.configId = this.$route.query.id
    this.getInfo(this.configId)
  },
  beforeDestroy () {
    if (this.t) {
      clearInterval(this.t);
      this.t = null;
    }
  },
  methods: {
    handleTreeNodeSelect (data) {
      if (data.disabled) {
        return
      }
      this.$refs.treeBox.setCurrentKey(data.id)
      this.handleNodeClick(data)
    },
    async handleNodeClick (data) {
      this.$store.commit("SET_SHOW_LOADING", true);
      this.activeData = data
      const result = data.records.reduce((obj, item) => {
        obj[item.questionId] = item.answer;
        return obj;
      }, {});
      this.paperId = data.id
      this.recordId = data.recordId
      this.makeInfo(data.sections, result);
      this.check = result
      setTimeout(() => {
        this.$store.commit("SET_SHOW_LOADING", false);
      }, 500);
    },
    toRouter (path) {
      this.$router.push({ path })
    },
    numToCapital (num, type) {
      if (!num) return 0;
      const strNum = Number((num + "").replace(/[,，]*/g, "")) + ""; // 记录字符
      num = parseInt(Number(strNum)); // 转为整数，
      let capitalAr = "零一二三四五六七八九十";
      let unitAr = [
        "十",
        "百",
        "千",
        "万",
        "十",
        "百",
        "千",
        "亿",
        "十",
        "百",
        "千",
      ];
      if (type) {
        capitalAr = "零壹贰叁肆伍陆柒捌玖拾";
        unitAr = [
          "拾",
          "佰",
          "仟",
          "万",
          "拾",
          "佰",
          "仟",
          "亿",
          "拾",
          "佰",
          "仟",
        ]; // 单位
      }
      const resultAr = []; // 记录结果，后边json.in就可
      let index = strNum.length - 1; //记录位数
      let idx = 0; // 记录单位
      let percent = 10;
      const turnNum = (num, percent, index) => {
        const unit = num / percent;
        const capital = capitalAr[Number(strNum[index])];
        if (unit < 1) {
          resultAr.push(capital);
          // 出现11【一十一】这种情况
          if (
            Number(strNum[index]) === 1 &&
            (strNum.length === 2 || strNum.length === 6 || strNum.length === 10)
          ) {
            resultAr.pop();
          }
          return false; //结束递归
        } else {
          if (capital === "零") {
            // 万和亿单位不删除
            if (!["万", "亿"].includes(resultAr[resultAr.length - 1])) {
              resultAr.pop();
            }
            // 前面有零在删掉一个零
            if (resultAr[resultAr.length - 1] === "零") {
              resultAr.pop();
            }
          }
          resultAr.push(capital);
          // 过滤存在【零万】【零亿】这种情况
          if (
            ["万", "亿"].includes(resultAr[resultAr.length - 2]) &&
            capital === "零"
          ) {
            resultAr.pop();
          }
          // 过滤【1亿万】这种情况
          if (resultAr[0] === "万" && resultAr[1] === "亿") {
            resultAr.shift();
          }
          // 末尾【零】删掉
          if (resultAr[0] === "零") {
            resultAr.pop();
          }
          resultAr.push(unitAr[idx++]);
          turnNum(num, percent * 10, --index);
        }
      };
      turnNum(num, percent, index);
      return resultAr.reverse().join("");
    },
    formatSeconds (time) {
      var d = Math.floor(time / (60 * 60 * 24));
      var h = Math.floor((time / 60 / 60) % 24);
      h = d * 24 + h
      h = h > 9 ? h : "0" + h;
      var m = Math.floor((time / 60) % 60);
      m = m > 9 ? m : "0" + m;
      var s = Math.floor(time % 60);
      s = s > 9 ? s : "0" + s;
      return h + ":" + m + ":" + s;
    },
    getInfo (id) {
      this.$http.get("/student/pc/evaluation/record/" + id).then((res) => {
        res.chapters.forEach((item) => {
          item.isClick = true
          item.disabled = false
          if (item.lessons) {
            item.lessons.forEach((lessonsItem) => {
              lessonsItem.disabled = true
            })
          }
        })
        if (res.chapters.length > 0) {
          this.activeData = res.chapters[0]
          const result = res.chapters[0].records.reduce((obj, item) => {
            obj[item.questionId] = item.answer;
            return obj;
          }, {});
          this.paperId = res.chapters[0].id
          this.recordId = res.chapters[0].recordId
          this.makeInfo(res.chapters[0].sections, result);
          this.check = result
        }
        this.treeData = res.chapters
        this.$nextTick(() => {
          this.$refs.treeBox.setCurrentKey(res.chapters[0].id);
        })
      });
    },
    makeInfo (res, answers) {
      //处理数据格式
      var that = this;
      res.map((item, index) => {
        item.type = item.questions[0].type;
        item.questions.map((v, i) => {
          if (v.type == "SINGLECHOICE" || v.type == "JUDGMENT") {
            // 单选、判断
            v.myAnswer = answers[v.id] ? answers[v.id] : "";
          } else if (v.type == "MULTIPLECHOICE") {
            //多选
            v.myAnswer = answers[v.id] ? answers[v.id].split("") : [];
          } else if (v.type == "BLANKFILL") {
            //填空
            v.myAnswer = [];
            if (answers[v.id]) {
              v.myAnswer = answers[v.id].split("`");
            } else {
              v.blanks.map((x) => {
                v.myAnswer.push("");
              });
            }
          } else if (item.type == "TT") {
            //套题
            v.children.map((v_, i_) => {
              if (v_.type == "SINGLECHOICE" || v_.type == "JUDGMENT") {
                // 单选、判断
                v_.myAnswer = answers[v_.id] ? answers[v_.id] : "";
              } else if (v_.type == "MULTIPLECHOICE") {
                //多选
                v_.myAnswer = answers[v_.id] ? answers[v_.id].split("") : [];
              } else if (v_.type == "BLANKFILL") {
                //填空
                v_.myAnswer = [];
                if (answers[v_.id]) {
                  v_.myAnswer = answers[v_.id].split("`");
                } else {
                  v_.blanks.map((x) => {
                    v_.myAnswer.push("");
                  });
                }
              } else {
                //文本
                v_.myAnswer = answers[v_.id] ? answers[v_.id] : "";
              }
            });
          } else {
            //文本
            v.myAnswer = answers[v.id] ? answers[v.id] : "";
          }
        });
      });
      this.sections = res;
    },
    reformHtml (html) {
      var reg = new RegExp("\\[BlankArea\\d]", "g");
      html = html.replace(reg, "____");
      return html.replace(/<p.*?>/gi, "").replace(/<\/p.*?>/gi, "");
    },
    change (data) {
      var oldArr = JSON.parse(JSON.stringify(this.sections))
      oldArr.map((v) => {
        v.questions.map((v_) => {
          if (v_.id == data.id) {
            v_.myAnswer = data.value;
          }
          if (v_.children) {
            v_.children.map((x) => {
              if (x.id == data.id) {
                x.myAnswer = data.value;
              }
            });
          }
        });
      });
      this.sections = oldArr
    },
    position (id) {
      //答题卡锚点定位
      const anchorEle = document.querySelector("#Q-" + id);
      if (!!anchorEle) {
        // anchorEle.scrollIntoView(true);
        var rect = anchorEle.getBoundingClientRect();
        window.scrollTo(0, rect.top + window.scrollY - 120);
      }
    },
    redoFn () {
      let that = this
      //重做
      this.$confirm("确定要重做（点击“确定”按钮后会清空这个成绩）？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        if (res == "confirm") {
          const formData = new FormData();
          formData.append("evaluationConfigId", that.configId);
          formData.append("evaluationRecordId", that.recordId);

          this.$http.put('/student/pc/evaluation/record', formData, { "Content-Type": "multipart/form-data", }).then((res) => {
            if (res) {
              this.$router.push({
                path: '/evaluationPaper',
                query: {
                  id: that.configId,
                }
              })
            }
          })
        }
      });
    },

  },
};
</script>
<style lang="scss" scoped>
.paperPage {
  padding-top: 90px;
  min-height: calc(100% - 200px);
  font-size: 14px;

  p {
    margin: 0;
  }

  .mianbao {
    color: #fff;
    margin-bottom: 20px;
  }

  .mid {
    width: 1200px;
    margin: 0 auto 30px auto;
    overflow: hidden;
    min-height: calc(100vh - 310px);

    .content {
      width: 830px;
      background: #ffffff;
      box-shadow: 0px 3px 10px 0px rgba(153, 153, 153, 0.25);
      border-radius: 10px;
      box-sizing: border-box;
      padding: 30px 0;
    }

    .paperInfo {
      .paperTitle {
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        color: #333;
      }

      .descBox {
        margin: 20px auto;

        p {
          margin: 0 30px;
          font-size: 14px;
          color: #999999;
        }
      }

      .scoreTable {
        width: 90%;
        margin: 10px auto;

        table {
          width: 100%;
          border: 1px solid;
          border-collapse: collapse;
          border-spacing: 10px 50px;

          td {
            border: 1px solid #c2c2c2;
            color: #666;
            font-size: 14px;
            padding: 5px;
            line-height: 22px;

            &:nth-of-type(1) {
              width: 60px;
            }
          }
        }
      }
    }

    .paperBox {
      width: 90%;
      margin: 0 auto;
      display: flex;

      .treeBox {
        width: 200px;
        margin-right: 20px;
        border-right: 1px solid #F2F2F2;
        padding-right: 20px;

        .el-tree {
          width: 100%;
        }

        ::v-deep .tree-node-label {
          display: block;
          width: 100%;
          cursor: pointer;
          height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        ::v-deep .tree-node-label.is-disabled {
          cursor: not-allowed;
          color: #c0c4cc;
        }
      }

      .list {
        flex: 1;

        .li {
          background: #fff;
          margin-bottom: 15px;
          border-bottom: 1px solid #F2F2F2;

          .titleBox {
            box-sizing: border-box;
            padding: 10px 0;
          }

          .liBox {
            margin: 20px 0;
            position: relative;

            .functionBox {
              position: absolute;
              top: -7.5px;
              right: 0;
              background: #fff;
              box-sizing: border-box;
              padding: 5px 10px;
              border-radius: 5px;
              box-shadow: 0 0 10px #ddd;
              z-index: 22;

              .collectBox {
                margin-left: 10px;

                img {
                  width: 24px;
                  height: 24px;
                }
              }
            }

            .boxView {
              position: relative;

              .functionBox {
                top: 0;
              }
            }
          }
        }
      }
    }

    .answerBox {
      width: 320px;
      box-sizing: border-box;
      padding: 0 10px;
      box-shadow: 0px 3px 10px 0px rgba(153, 153, 153, 0.25);
      border-radius: 10px;
      right: calc(50% - 600px);
      position: fixed;
      top: 170px;
      background: #fff;
      z-index: 99;
      overflow: hidden;

      .timeBox {
        height: 80px;
        border-bottom: 1px solid #f2f2f2;
        font-size: 16px;

        b {
          color: #FFA800;
          font-size: 34px;
          margin-left: 10px;
          font-weight: 500;
        }
      }
    }

    .bottomBox {
      width: 100%;
      box-sizing: border-box;
      padding: 10px;

      .uploadBtn {
        margin-left: 15px;
      }
    }

    .imgBox {
      box-sizing: border-box;
      padding: 0 10px;
      border: 1px solid #ddd;
      border-radius: 5px;
      background: #fff;
      margin-bottom: 15px;
      width: 90%;
      margin: 30px auto;

      .img_title {
        box-sizing: border-box;
        padding: 10px;
        border-bottom: 1px solid #eee;
      }

      .imgs {
        display: flex;
        justify-items: center;
        flex-wrap: wrap;

        .box {
          box-shadow: 0 0 1px;
          margin: 10px;
          position: relative;
          border-radius: 5px;
          width: 100px;
          height: 100px;

          .img {
            width: 100%;
            height: 100%;
            border-radius: 5px;
            cursor: pointer;
          }

          .fileBox {
            width: 100%;
            height: 100%;

            img {
              width: 60%;
              height: 60%;
              position: relative;
              top: 20%;
              left: 20%;
              cursor: pointer;
            }
          }

          .icon {
            position: absolute;
            top: -8px;
            right: -8px;
            font-size: 20px;
            color: red;
            cursor: pointer;
            background: #fff;
            border-radius: 50%;
          }
        }
      }
    }

    .scoreBox {
      height: 16px;

      img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }
  }
}
</style>